// Branding config — override any value via .env for each client deployment.
// All REACT_APP_* vars are set at build time.

const branding = {
  name:         process.env.REACT_APP_BRAND_NAME         || 'UPwala',
  nameHi:       process.env.REACT_APP_BRAND_NAME_HI      || 'यूपीवाला',
  tagline:      process.env.REACT_APP_BRAND_TAGLINE       || 'UP ki har khabar',
  taglineHi:    process.env.REACT_APP_BRAND_TAGLINE_HI   || 'यूपी की हर खबर',
  description:  process.env.REACT_APP_BRAND_DESCRIPTION  || 'Latest news from every district of Uttar Pradesh, plus national, business, sports and technology.',
  descriptionHi:process.env.REACT_APP_BRAND_DESCRIPTION_HI || 'उत्तर प्रदेश के हर जिले की ताज़ा खबरें, साथ ही देश, व्यापार, खेल और टेक्नोलॉजी।',
  email:        process.env.REACT_APP_BRAND_EMAIL        || 'contact@upwala.in',
  phone:        process.env.REACT_APP_BRAND_PHONE        || '+91 9876 543 210',
  address:      process.env.REACT_APP_BRAND_ADDRESS      || 'Lucknow, Uttar Pradesh, India',
  addressHi:    process.env.REACT_APP_BRAND_ADDRESS_HI   || 'लखनऊ, उत्तर प्रदेश, भारत',
  siteUrl:      process.env.REACT_APP_SITE_URL           || 'https://upwala.in',
};

export default branding;
